import type { NextApiRequest, NextApiResponse } from 'next'
import type { IncomingMessage, ServerResponse } from 'http'
import logger from '@reward-platform/logger/server/next'
import { createServerLoggerMeta } from '@reward-platform/logger/utils'
import { Auth0B2CException } from './Auth0B2CException'

export const logAuth0Error = (
  message: string,
  err: Auth0B2CException,
  req: IncomingMessage,
  res: ServerResponse
) => {
  // Log error to datadog
  const loggerContext = createServerLoggerMeta(req, res)
  logger.error(message, {
    ...err.formatErrorForLogs('auth_b2c'),
    ...loggerContext,
  })
}

export const handleAuth0ErrorStatus = (
  err: Auth0B2CException,
  req: NextApiRequest,
  res: NextApiResponse
) => {
  res.status(err.httpStatus).send(err.getErrorResponse())
}
